module.exports = __webpack_public_path__ + "img/profits_1.44754cc0.png";